/* eslint-disable */

import request from '@/utils/request'
import { getUserApi } from '@/api/userConfig/user'

export function getSourceApi(query) {
  return request({
    url: '/config-service/v1/statistic/source-group/source',
    method: 'get',
    params: query
  })
}

export function getSourceOTAApi(query) {
  return request({
    url: '/report-service/v1/hotellink-report/list-ota',
    method: 'get',
    params: query
  })
}

export function addSourceApi(query) {
  return request({
    url: '/config-service/v1/statistic/source-group/source',
    method: 'post',
    data: query
  })
}

export function updateSourceApi(query) {
  return request({
    url: '/config-service/v1/statistic/source-group/source',
    method: 'put',
    data: query
  })
}
export function deleteSourceApi(query) {
  return request({
    url: '/config-service/v1/statistic/source-group',
    method: 'delete',
    data: query
  })
}

export async function getAllBusinessMan() {
  let res = null
  try {
    res = await getUserApi({ department: 'SALE' })
    if (res.is_error) {
      throw new Error(res)
    }
  } catch (error) {
    console.log(error)
    Message({
      message: 'Lỗi!',
      type: 'error'
    })
  } finally {
    //
  }
  return (
    res?.data.map(item => ({
      ...item,
      id: item.account.id,
      username: item.account.username,
      full_name: item.account.full_name
    })) || []
  )
}
